import type { UpdateUiStatetInput } from '@infinex/main-service-contract/v2/client/user';
import {
  type PathValue,
  type UserUiState,
  type UserUiStatePath,
} from '@infinex/types';

import { useOptimisticUiStateStore } from '../../stores';
import { getApiClientV2 } from '../config';

export function useOptimisticUiStateMutation<Path extends UserUiStatePath>() {
  const apiClient = getApiClientV2();
  const addOptimisticUpdate = useOptimisticUiStateStore(
    (state) => state.addOptimisticUpdate
  );
  const removeOptimisticUpdate = useOptimisticUiStateStore(
    (state) => state.removeOptimisticUpdate
  );

  async function mutate(
    path: Path,
    value: PathValue<UserUiState, Path> | null
  ) {
    const updateId = addOptimisticUpdate(path, value);
    try {
      const updateUiStatetInput: UpdateUiStatetInput = {
        update: {
          path,
          value,
        },
      };
      await apiClient.user.updateUiState.mutate(updateUiStatetInput);
      // If successful, let the update expire naturally
    } catch (error) {
      // On error, immediately remove the optimistic update
      removeOptimisticUpdate(updateId);
      throw error;
    }
  }

  return {
    mutate,
  };
}
